import { useState } from "react";
import Logo from "../../Assests/Images/logo.png"; // Path check kar lein
import { useNavigate } from "react-router-dom";

export default function FuelingoFooter2() {
  const [email, setEmail] = useState("");
  const [showMsg, setShowMsg] = useState(false);
const navigate = useNavigate();
  const handleSubscribe = () => {
    if (!email) return;
    setShowMsg(true);
    setEmail("");
    setTimeout(() => setShowMsg(false), 3000);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

        .footer {
          background: #0a0a0a;
          font-family: 'Inter', sans-serif;
          color: white;
          width: 100%;
        }

        .container {
          max-width: 1200px;
          margin: auto;
          padding: 80px 40px 40px;
        }

        .grid {
          display: grid;
          grid-template-columns: 1.5fr 0.8fr 1.2fr;
          gap: 60px;
          align-items: start;
        }

        .logo {
          width: 140px;
          margin-bottom: 24px;
        }

        .desc {
          font-size: 14px;
          color: rgba(255,255,255,0.55);
          line-height: 1.7;
          text-align: left;
          max-width: 320px; /* Desktop ke liye restricted */
        }

        .title {
          font-size: 15px;
          font-weight: 600;
          margin-bottom: 20px;
          color: #ffffff;
        }

        .link-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .link-item {
          font-size: 14px;
          color: rgba(255,255,255,0.7);
          cursor: pointer;
          transition: 0.2s;
          margin-bottom: 12px;
        }

        .link-item:hover {
          color: white;
        }

        .newsletter-text {
          font-size: 14px;
          color: rgba(255,255,255,0.75);
          line-height: 1.6;
          margin-bottom: 20px;
        }

        .input-group {
          display: flex;
          gap: 10px;
          width: 100%;
        }

        .input {
          flex: 1;
          background: rgba(255,255,255,0.05);
          border: 1px solid rgba(255,255,255,0.1);
          border-radius: 10px;
          padding: 12px 16px;
          color: white;
          font-size: 14px;
          outline: none;
          transition: 0.2s;
        }

        .input:focus {
          border-color: #E53935;
          background: rgba(255,255,255,0.08);
        }

        .btn {
          background: #E53935;
          border: none;
          padding: 12px 24px;
          border-radius: 10px;
          font-size: 14px;
          font-weight: 600;
          color: white;
          cursor: pointer;
          transition: 0.3s;
          white-space: nowrap;
        }

        .btn:hover {
          background: #c62828;
          transform: translateY(-2px);
        }

        .success {
          font-size: 12px;
          color: #4caf50;
          margin-top: 10px;
        }

        .bottom {
          border-top: 1px solid rgba(255,255,255,0.08);
          margin-top: 80px;
          padding-top: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 13px;
          color: rgba(255,255,255,0.4);
        }

        .bottom-links {
          display: flex;
          gap: 24px;
        }

        .bottom-links span {
          cursor: pointer;
          transition: 0.2s;
        }

        .bottom-links span:hover {
          color: white;
        }

        /* --- MOBILE RESPONSIVE --- */
        @media (max-width: 991px) {
          .grid {
            grid-template-columns: 1fr;
            gap: 40px;
          }
          
          .container {
             padding: 60px 24px 40px;
          }

          .desc {
            max-width: 100%; /* Mobile par full width */
            text-align: left;
          }

          .bottom {
            flex-direction: column;
            align-items: flex-start;
            gap: 20px;
            margin-top: 50px;
          }

          .input-group {
            flex-direction: row; /* Chhote screens par bhi row sahi lagti hai usually */
          }
        }

        @media (max-width: 480px) {
          .input-group {
            flex-direction: column; /* Bilkul chhote phones ke liye column stack */
          }
          .btn {
            width: 100%;
          }
        }
      `}</style>

      <footer className="footer">
        <div className="container">

          <div className="grid">
            {/* LEFT - Brand */}
            <div className="footer-brand">
              <img src={Logo} className="logo" alt="Fuelingo" />
              <p className="desc">
                If you don't find an answer to your question, contact us,
                and our team will get in touch with you.
              </p>
            </div>

            {/* CENTER - Quick Links */}
            <div>
              <h4 className="title">Links</h4>
              <ul className="link-list">
                <li className="link-item" onClick={() => navigate("/") }>Home</li>
                {/* <li className="link-item">Services</li>
                <li className="link-item">Become a Provider</li> */}
              </ul>
            </div>

            {/* RIGHT - Newsletter */}
            <div>
              <h4 className="title">Newsletter</h4>
              <p className="newsletter-text">
                Join our newsletter to stay up to date on features and releases.
              </p>

              <div className="input-group">
                <input
                  className="input"
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button className="btn" onClick={handleSubscribe}>
                  Subscribe
                </button>
              </div>

              {showMsg && (
                <div className="success">
                  Subscribed successfully ✅
                </div>
              )}
            </div>
          </div>

          {/* BOTTOM - Legal */}
          <div className="bottom">
            <span>© 2026 Fuelingo. All rights reserved.</span>
            <div className="bottom-links">
              <span onClick={() => navigate("/PrivacyPolicy")}>Privacy Policy</span>
              <span onClick={() => navigate("/TermsOfService")}>Terms of Service</span>
            </div>
          </div>

        </div>
      </footer>
    </>
  );
}